import {BankDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'CREATE_BANK';

export async function createBank(
    userData: Record<string, string>,
    bank: Record<string, any>
) {
    try {
        const result = await BankDao.createBank(userData.userToken, bank);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
